import { InboxView } from "./_components";

export default function InboxPage() {
  return <InboxView />;
}
